import { APP_ROUTES } from "../constants";

/** First path segments that are app routes, not a magic-link id. */
const KNOWN_ROUTE_SEGMENTS = new Set(
  Object.values(APP_ROUTES)
    .map((route) => route.replace(/^\//, "").split("/")[0])
    .filter(Boolean)
);

/**
 * Reads the magic-link id from the URL: `?linkId=` first, then the first path
 * segment when it is not a known app route (`/:linkId` entry).
 */
export function resolveUrlLinkId(
  pathname?: string,
  search?: string | URLSearchParams
): string | null {
  const path =
    pathname ??
    (typeof window !== "undefined" ? window.location.pathname : "");
  const rawSearch =
    search ??
    (typeof window !== "undefined" ? window.location.search : "");
  const params =
    rawSearch instanceof URLSearchParams
      ? rawSearch
      : new URLSearchParams(
          rawSearch.startsWith("?") ? rawSearch.slice(1) : rawSearch
        );

  const fromQuery = params.get("linkId");
  if (fromQuery) return fromQuery;

  const firstSegment = path.split("/").filter(Boolean)[0];
  if (firstSegment && !KNOWN_ROUTE_SEGMENTS.has(firstSegment)) {
    return firstSegment;
  }
  return null;
}
